import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Button from '../../common/CustomComponents/Button.js'

class AirportAdd extends React.Component {
  state = {
    iata_code: '',
    name: '',
    name_ar: '',
    city: '',
    city_ar: '',
    country: '',
    country_ar: '',
    isSaving: false,
    isData: false,
    Edit: false,
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.id) {
        this.getAirportDetails()
      }
    }, 100)
  }

  getAirportDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/get-airport-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ ...res.data.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {
    var that = this

    const formData = new FormData()

    formData.append('iata_code', this.state.iata_code)
    formData.append('name', this.state.name)
    formData.append('name_ar', this.state.name_ar)
    formData.append('city', this.state.city)
    formData.append('city_ar', this.state.city_ar)
    formData.append('country', this.state.country)
    formData.append('country_ar', this.state.country_ar)

    that.setState({ isData: true })

    if (this.props.id) {
      formData.append('id', this.props.id)

      axios
        .put(Constant.getAPI() + '/admin/update-airport', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Record has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/admin/add-airport', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Record has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">IATA Code</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="iata_code"
                    id="iata_code"
                    placeholder={`IATA Code`}
                    maxLength={3}
                    onChange={this.handleChange}
                    value={this.state.iata_code}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Airport Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    placeholder={`Airport Name: English`}
                    onChange={this.handleChange}
                    value={this.state.name}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Airport Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    id="name_ar"
                    placeholder={`Airport Name: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">City: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    id="city"
                    placeholder={`City: English`}
                    onChange={this.handleChange}
                    value={this.state.city}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">City: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="city_ar"
                    id="city_ar"
                    placeholder={`City: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.city_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Country: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="country"
                    id="country"
                    placeholder={`Country: English`}
                    onChange={this.handleChange}
                    value={this.state.country}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Country: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="country_ar"
                    id="country_ar"
                    placeholder={`Country: Arabic`}
                    onChange={this.handleChange}
                    value={this.state.country_ar}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-right">
              <Button
                disabled={this.state.isData}
                onClick={this.onSaveData}
                startIcon={<i className="icofont icofont-save"></i>}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AirportAdd
